// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmileOutlinedSvg from "@ant-design/icons-svg/es/asn/SmileOutlined";
import AntdIcon from '../components/AntdIcon';

var SmileOutlined = function SmileOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SmileOutlinedSvg
  }));
};

SmileOutlined.displayName = 'SmileOutlined';
export default React.forwardRef(SmileOutlined);